import { extendTheme } from '@mui/material/styles'
import {
  muiDialogActionsResponsive,
  muiDialogContentResponsive,
  muiDialogPaperResponsive,
} from './responsiveModalOverrides'

// Theme de MUI Material para coexistir con MUI Joy mediante THEME_ID.
// Los componentes de @mui/material (Dialog, Tooltip, etc.) necesitan un theme
// de Material con `transitions`, `zIndex`, `palette.mode`, etc. — que el theme
// de Joy (chateamTheme) NO provee. Sin esto, el Dialog crashea al leer
// `theme.transitions.duration`. Ver docs oficiales: Joy UI + Material UI.
//
// Además define el comportamiento responsive de los <Dialog> de Material (los
// 12 modales de FlowBuilder): paper acotado al viewport, DialogContent como
// única zona scrolleable y DialogActions sticky para que los botones Guardar /
// Cancelar nunca queden fuera de la pantalla.
// Ver theme/responsiveModalOverrides.ts para el detalle del problema.
const materialTheme = extendTheme({
  components: {
    MuiDialog: {
      defaultProps: {
        // Hace que el scroll ocurra dentro del paper y no en el contenedor.
        scroll: 'paper',
      },
      styleOverrides: {
        paper: muiDialogPaperResponsive,
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: muiDialogContentResponsive,
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: muiDialogActionsResponsive,
      },
    },
  },
})

export default materialTheme
